/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigScopeDetailsForAwsServiceAccount extends models.LockConfigScopeDetailsBaseForServiceAccount {
    constructor() {
        super();
        this.setDiscriminator("LockConfigScopeDetailsForAwsServiceAccount");
    }

    getFixupPrototypeFunction() { return LockConfigScopeDetailsForAwsServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<LockConfigScopeDetailsForAwsServiceAccount>): LockConfigScopeDetailsForAwsServiceAccount {
        let obj = Object.assign(new LockConfigScopeDetailsForAwsServiceAccount(), model);
        LockConfigScopeDetailsForAwsServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigScopeDetailsForAwsServiceAccount>): LockConfigScopeDetailsForAwsServiceAccount {
        if (!model) return null;
        return LockConfigScopeDetailsForAwsServiceAccount.newInstance(<LockConfigScopeDetailsForAwsServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigScopeDetailsForAwsServiceAccount) {
        if (!obj) return;

        models.LockConfigScopeDetailsForAwsServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigScopeDetailsForAwsServiceAccount): boolean {
        if (models.LockConfigScopeDetailsBaseForServiceAccount.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LockConfigScopeDetailsForAwsServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.regions) {
            for (let val of this.regions) {
                models.AwsRegion.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Aws regions
     */
    regions: Array<models.AwsRegion>;

}
